import React from 'react';
import { Slider } from '@react-native-assets/slider';
import { colors } from '../../../utils/theme';

export type ProgressSliderOwnProps = {
    duration: number;
    currentTime: number;
    onValueChange: (value: number) => void;
    onSlideStart: () => void;
    isDisabled?: boolean;
    seekPosition: number | null;
    onSeekPositionChange: (value: number | null) => void;
};

export type ProgressSliderProps = ProgressSliderOwnProps;

const ProgressSlider: React.FC<ProgressSliderProps> = (props) => {
    const [isSliding, setIsSliding] = React.useState(false);
    const valueToUse = isSliding ? props.seekPosition || 0 : props.currentTime;

    const disabledColor = colors['Secondary-Button-Inactive'];
    return (
        <Slider
            style={{ width: '100%' }}
            value={valueToUse}
            maximumValue={props.duration || 1000000}
            onValueChange={(value) => {
                if (props.isDisabled) return;

                props.onSeekPositionChange(value);
            }}
            onSlidingStart={() => {
                if (props.isDisabled) return;

                setIsSliding(true);
                props.onSlideStart();
            }}
            onSlidingComplete={(value) => {
                if (props.isDisabled) return;

                props.onValueChange(value);
                props.onSeekPositionChange(null);
                setIsSliding(false);
            }}
            thumbSize={24}
            thumbStyle={{
                backgroundColor: props.isDisabled ? disabledColor : colors['Primary-Reg-Dark'],
            }}
            trackStyle={{
                backgroundColor: props.isDisabled ? disabledColor : colors['Grey-Light'],
            }}
            minTrackStyle={{
                backgroundColor: props.isDisabled ? disabledColor : colors['Primary-Reg'],
            }}
        />
    );
};

export default React.memo(ProgressSlider);
